import {
  Avatar,
  Card,
  CardContent,
  Stack,
  Typography,
  Box,
  SxProps,
  Theme,
  Rating,                // ⬅️ added
} from "@mui/material";

export type TestimonialCardProps = {
  name: string;
  role?: string;
  quote: string;
  initials?: string;          // optional; auto-generated from name if omitted
  avatarColor?: string;       // any CSS color; defaults to a teal-like tone
  rating?: any;            // ⬅️ added (0–5, supports halves)
  sx?: SxProps<Theme>;        // to extend/override styles if needed
};

const getInitials = (fullName: string) =>
  fullName
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("");

export default function TestimonialCard({
  name = "Sally Harry",
  role = "Founder",
  quote = `Your designs absolutely blew my mind - they were something I couldn’t have gotten from any designer. It was honestly a revolutionary moment for our brand!`,
  initials,
  avatarColor = "#10B981", // teal-500 vibe
  rating,                   // ⬅️ added
  sx,
}: TestimonialCardProps) {
  const _initials = initials || getInitials(name);

  return (
    <Card
      elevation={0}
      sx={{
        maxWidth: 520,
        borderRadius: 3, // ~24px if your theme.shape.borderRadius=8; adjust to taste
        border: "1px solid",
        borderColor: (t) => (t.palette.mode === "light" ? "grey.200" : "grey.800"),
        boxShadow:
          "0 1px 2px rgba(0,0,0,0.04), 0 10px 15px -3px rgba(0,0,0,0.06)",
        bgcolor: "background.paper",
        ...sx,
      }}
    >
      <CardContent sx={{ p: 3 }}>
        {/* Header: Avatar + Name + Subtitle */}
        <Stack direction="row" spacing={2} alignItems="center">
          <Box
            sx={{
              position: "relative",
              width: 56,
              height: 56,
              borderRadius: "50%",
              boxShadow: "0 0 0 4px #fff, 0 0 0 1px rgba(0,0,0,0.06)",
            }}
          >
            <Avatar
              variant="circular"
              sx={{
                width: "100%",
                height: "100%",
                bgcolor: avatarColor,
                fontWeight: 700,
                color: "#fff",
              }}
            >
              {_initials}
            </Avatar>
          </Box>

          <Box>
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: 600, lineHeight: 1.2 }}
            >
              {name}
            </Typography>


            {/*  Stars rating (optional) */}
            {typeof rating === "number" && (
              <Rating
                value={rating}
                precision={0.5}
                readOnly
                size="small"
                sx={{ mt: 0.5, mb: 0 }}
                aria-label={`Rating ${rating} out of 5`}
              />
            )}

            <Typography
              variant="body2"
              color="text.secondary"
              sx={{ mt: 0 }}
            >
              Rating {rating} out of 5
            </Typography>
            
          </Box>
        </Stack>

        {/* Quote */}
        <Typography
          variant="body1"
          sx={{
            mt: 2.5,
            color: "text.primary",
            lineHeight: 1.7,
          }}
        >
          {quote}
        </Typography>
      </CardContent>
    </Card>
  );
}
